import { Power1, TweenMax } from 'gsap';
import { Collection } from '../../../Tiles/TileSet';
import { getSpriteId } from '../../../Utils/CollectableUtils';
import { BoardSprite } from './BoardSprite';

export class ObjectSprite extends BoardSprite {
    public objectSprite: PIXI.Sprite;
    public isHit: boolean = false;

    constructor(tileSize: [number, number], collection: Collection) {
        super(getSpriteId('tile-special', collection), tileSize, collection);
        this.spriteId = 'special';
        this.interactive = false;
    }

    public playMatch(targetPosition: [number, number]) {
        this.isMatched = true;
        TweenMax.to(this, 0.75, {
            ease: Power1.easeOut,
            onComplete: () => this.destroy(),
            x: targetPosition[0] / this.scale.x,
            y: targetPosition[1] / this.scale.y,
        });
        TweenMax.to(this.scale, 0.2, { x: 0, y: 0, delay: 0.4, ease: Power1.easeOut });
    }

    public dim(ms: number) {}

    public revealAvailable(ms: number) {}
}
